const selectors = {
  customerSearch: (state) => state.createInvoice.customerSearch,
  itemSearch: (state) => state.createInvoice.itemSearch,
  fetchingSearchStatus: (state) => state.createInvoice.fetchingSearchStatus,
  defaultInvoiceInfo: (state) => state.createInvoice.defaultInvoiceInfo,
  invoiceId: (state) => state.createInvoice.invoiceId,
  createInvoiceStatus: (state) => state.createInvoice.createInvoiceStatus,
  createItemStatus: (state) => state.createInvoice.createItemStatus,
  invoiceItems: (state) => state.createInvoice.invoiceItems,
  editItemStatus: (state) => state.createInvoice.editItemStatus,

  relatives: (state) => state.createDancer.relatives,
  createGuardianStatus: (state) => state.createDancer.createGuardianStatus,
  fetchingRelativesStatus: (state) =>
    state.createDancer.fetchingRelativesStatus,
  submitDancerCreationStatus: (state) =>
    state.createDancer.submitDancerCreationStatus,
};

export { selectors };
